"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api = async (uri, { query, variables }) => {
    try {
        const graphqlUri = `${uri}`;
        const fetchOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                // Compress the response, otherwise the query will take a long time.
                'Accept-Encoding': `gzip, deflate, br`
            },
            body: JSON.stringify({
                query: query,
                variables: variables || {}
            })
        };
        const response = await fetch(graphqlUri, fetchOptions);
        const { data } = await response.json();
        return data;
    }
    catch (error) {
        throw new Error(error);
    }
};
exports.default = api;
//# sourceMappingURL=api.js.map